var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"width":'400px',"isShow":_vm.delDialog,"title":"提示","isShowBtn":[true,true],"btnText":['取消','确认']},on:{"update:isShow":function($event){_vm.delDialog=$event},"update:is-show":function($event){_vm.delDialog=$event},"clickHandler":_vm.ClickHandler}},[_c('div',{staticClass:"dialog-conter"},[_vm._v("是否确认删除")])])
}
var staticRenderFns = []

export { render, staticRenderFns }